module.exports = __webpack_public_path__ + "files/c7cdc45d781061e93bb08ee594127ed8.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo_compact.png
// module id = 695
// module chunks = 27